// Configuration de l'API backend chargée depuis config.json
import configData from '../config.json';

const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || configData.baseURL,
  endpoints: configData.endpoints,
  timeout: configData.timeout,
};

// Helper pour construire l'URL complète
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.baseURL}${endpoint}`;
};

// Helper pour obtenir l'endpoint d'un exercice
export const getExerciseEndpoint = (subject, level) => {
  return API_CONFIG.endpoints[subject]?.[`exercise${level}`] || '';
};

export default API_CONFIG;
